module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Chat":"Chat","Introduction":"Introduction","exam":"exam","sign":"sign","schedule":"schedule"},"zh":{"Chat":"聊 天","Introduction":"回放列表","exam":"直播现场","sign":"回放列表","schedule":"直播现场"}}')
  delete Component.options._Ctor
}
